export default __webpack_public_path__ + "4318d52fcec10b048be75029a7f45d3c.png";